import { storeToRefs } from "pinia"
import { helpers } from "@vuelidate/validators"
import type { RentalIntakeItem } from "@/models/rental-intake-item.model.ts"
import { useRentalIntakeItemStore } from "@/store/rental-intake-item.store.ts"

export const uniqueRentalIntakeItemValidator = helpers.withMessage(
  "Er bestaat al een inhuurartikel met deze naam, eenheid en leverancier",
  (rentalIntakeItem: RentalIntakeItem) => {
    const rentalIntakeItemStore = useRentalIntakeItemStore()
    const { rentalIntakeItems } = storeToRefs(rentalIntakeItemStore)

    if (!rentalIntakeItem.name || !rentalIntakeItem.unit || !rentalIntakeItem.supplier) {
      return true
    }

    return !rentalIntakeItems.value.some(
      (item) =>
        item.name.toLowerCase() === rentalIntakeItem.name.toLowerCase() &&
        item.unit === rentalIntakeItem.unit &&
        item.supplier.id === rentalIntakeItem.supplier.id &&
        item.id !== rentalIntakeItem.id
    )
  }
)
